<template>
  <div class="container text-block">
    <html-block
      class="text-block__child"
      :class="class_list"
      :content="content"/>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";

export default {
  name: "TextBlock",
  components: {HtmlBlock},
  props: {
    /**props**/
    content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    tables_centered: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
  computed: {
    class_list() {
      return {
        tables_centered: this.tables_centered,
      }
    }
  }
}
</script>
